(ns ui.editors.card.property-list.sub
  (:require
   [re-frame.core :as rf]
   [common.util :as cu]
   [ui.editors.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [common.localization :as loc]

   ;; TODO remove this import later because it uses frontend.session
   [frontend.view.field-templates :as templates]
   [clojure.set :as set]))

(rf/reg-sub
 ::card-rows
 :<- [::common-sub/card-config]
 (fn [card-config]
   (:rows card-config)))

(rf/reg-sub
 ::card-row-count
 :<- [::card-rows]
 (fn [card-rows]
   (count card-rows)))

(rf/reg-sub
 ::card-row
 :<- [::card-rows]
 (fn [card-rows [_ row-index]]
   (nth card-rows row-index)))

(rf/reg-sub
 ::card-cells
 :<- [::card-rows]
 (fn [card-rows]
   (->> card-rows
        (map-indexed
         (fn [row-index {:keys [cells]}]
           (->> cells
                (map-indexed
                 (fn [cell-index cell]
                   (assoc cell
                          :row-index row-index
                          :cell-index cell-index))))))
        (flatten)
        (vec))))

(rf/reg-sub
 ::preview-disabled-message
 :<- [::card-cells]
 (fn [card-cells]
   (let [message (cond
                   (empty? card-cells)
                   (loc/tr :card-editor/property-list-add-at-least-one-field)
                   :else nil)]
     message)))

(rf/reg-sub
 ::preview-disabled?
 :<- [::preview-disabled-message]
 (fn [preview-disabled-message]
   (boolean preview-disabled-message)))

(rf/reg-sub
 ::selected-fields-set
 :<- [::card-cells]
 (fn [card-cells]
   (->> card-cells
        (map (fn [cell]
               (:field cell)))
        (remove cu/empty-value?)
        (set))))

;; TODO investigate if this works correctly in all cases
(rf/reg-sub
 ::all-field-options
 :<- [::common-sub/entity-type]
 :<- [::session-sub/tenant-schema]
 (fn [[entity-type tenant-schema]]
   (let [schema (templates/entity-type-template
                 {:entity-type     entity-type
                  :selected-fields []
                  :tenant-schema   tenant-schema
                  :account         nil
                  :role            nil
                  ;; TODO: Which fields should be removed?
                  :remove-fields   #{:common/named-network-drives
                                     :common/folder-structure
                                     :company/financials
                                     :asset/coordinates
                                     :common/attachments}
                  :overrides       nil})
         all-options (->> schema
                          (remove (fn [[_ field-schema]]
                                    (:field/secondary-field? field-schema)))
                          (mapv (fn [[field field-schema]]
                                  (let [label (loc/field-name field field-schema)]
                                    {:value field
                                     :label label})))
                          (sort-by :label))]
     all-options)))

(rf/reg-sub
 ::available-field-options
 (fn [[_ current-field]]
   [(rf/subscribe [::all-field-options])
    (rf/subscribe [::selected-fields-set])])
 (fn [[all-field-options selected-fields-set]
      [_ current-field]]
   (let [non-option-fields-set (set/difference selected-fields-set #{current-field})
         options (->> all-field-options
                      (remove (fn [{:keys [value]}]
                                (contains? non-option-fields-set value)))
                      (vec))]
     options)))
